import type { FaireProductEntity } from "../../entity_types/product";

export const p_vegvkzmg3j: FaireProductEntity = {
  token: "p_vegvkzmg3j",
  type: "product",
  name: "Antique Two Tone Wire Wrapped Dragonfly Charm Neckla",
  brandToken: "b_nnzc8s53xn",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5d6732466b6fcd68a662a2ea0d0129a663c1e007c8c932966c0fb8d505c840d5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5f94d0b6a23cab385fbd2b0cd48ddfea3edd395ae387d82d41a3f4d39b553966.jpeg",
  ],
  priceDollars: 12,
  description:
    '* Approx. 16" - 18" in length \n * Pendant: 1" in length \n\nExpertly crafted with antique two tone wire, this dragonfly charm necklace is a unique and stylish addition to any outfit. The intricate wire wrapping adds a touch of elegance, while the dragonfly charm brings a sense of nature and freedom. A must-have for any fashion-forward individual.',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:44.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
